<template>
    <ui-PanelOverlay panel="config" :show="show">
        <template v-slot:menuBar>
            <PanelMixinBack></PanelMixinBack>
        </template>
        <template v-slot:body>
            <ui-RichMenu :name="$dicc.configPanel.title" :navigation="true">
                <template v-slot:options>
                    <ui-RichMenuOption
                        :name="$dicc.configPanel.opctionUser"
                        icono="user"
                        @click="$emit('optionsClick', 'user')"
                        @clickAction="$emit('optionsClick', 'user')"
                    ></ui-RichMenuOption>
                    <ui-RichMenuOption
                        :name="$dicc.configPanel.opctionLocations"
                        icono="ubications"
                        @click="$emit('optionsClick', 'locations')"
                        @clickAction="$emit('optionsClick', 'locations')"
                    ></ui-RichMenuOption>
                    <ui-RichMenuOption
                        :name="$dicc.configPanel.opctionConfiguration"
                        icono="cogs"
                        @click="$emit('optionsClick', 'configuration')"
                        @clickAction="$emit('optionsClick', 'configuration')"
                    ></ui-RichMenuOption>
                    <ui-RichMenuOption
                        :name="$dicc.configPanel.opctionInfo"
                        icono="info"
                        @click="$emit('optionsClick', 'info')"
                        @clickAction="$emit('optionsClick', 'info')"
                    ></ui-RichMenuOption>
                    <ui-RichMenuOption
                        :name="$dicc.configPanel.logoutAction"
                        :logout="true"
                        @click="Logout"
                    ></ui-RichMenuOption>
                </template>
            </ui-RichMenu>
        </template>
    </ui-PanelOverlay>
</template>

<script>
    // :class="{ modeHeat: device.status.m != '0' }" class="fulldevice"
    import { PanelMixin } from '../mixins/PanelMixin';

    export default {
        name: 'ConfigPanel',
        mixins: [PanelMixin],
        props: {},
        data: function() {
            return {
                type: 'config',
            };
        },
        methods: {
            Logout: function() {
                this.$session.logout();
                this.$router.push({ name: 'Login' });
            },
        },
    };
</script>
